import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { GlobalState } from "../../../store/global/global.reducer";
import { selectMainNavOpen, selectPageTitle } from "../../../store/global/global.selectors";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { ButtonComponent } from "../Button/Button.component";
import { ComponentLoaderService } from "../../../services/component-loader/component-loader.service";
import { NgClass } from "@angular/common";


@Component({
  selector: "dotcom-frontend-header-links",
  templateUrl: "./HeaderLinks.component.html",
  styleUrl: "./HeaderLinks.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    LoaderComponent,
    ButtonComponent,
    NgClass
  ]
})
export class HeaderLinksComponent implements OnInit {
  @Input() headerLinksData: any | undefined;
  headerData: any | undefined;
  pageTitle = "";
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  isNavOpen = false;
  isNavOpen$: Observable<boolean> = this.store.select(selectMainNavOpen);
  tabIndex = 0;
  countrySelectorModal: any | null;
  countryName: any | undefined;
  countryFlag: any | undefined;
  hideHeaderLinks = false;

  constructor(
    private store: Store<{ global: GlobalState }>,
    private componentLoaderService: ComponentLoaderService,
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });

    this.isNavOpen$.subscribe((open) => {
      this.isNavOpen = open;
      this.tabIndex = this.isNavOpen ? -1 : 0;
    });
  }

  async ngOnInit() {
    if (this.headerLinksData && this.headerLinksData["headerLinks"]) {
      this.headerData = this.headerLinksData["headerLinks"];

      this.hideHeaderLinks = this.headerLinksData['headerStyle'] === "tall" && this.headerLinksData['headerTitle']?.trim().length > 0;


    }

    if (this.headerLinksData && this.headerLinksData["countryInfo"]) {
      this.countryName = this.headerLinksData["countryInfo"][0]["contentLink"]["expanded"]["countryName"] || undefined;
      this.countryFlag = this.headerLinksData["countryInfo"][0]["contentLink"]["expanded"]["flag"] || undefined;

      this.countrySelectorModal = await this.componentLoaderService.loadComponent(
        "Modal",
        "globals",
        {
          modalData: {contentLink: this.headerLinksData["countryRegionSelector"]},
          buttonIcon: this.countryFlag,
          modalLinkText: this.countryName,
        }
      );
    }
  }
}
